/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.primary-nav' ).slideToggle();
      } );

      $( '.subdropdown-toggle' ).on( 'toggleAfter', ( event ) => {
        $( $( event.target ).attr( 'data-toggle-target' ) ).slideToggle();
      } );

      // if ( window.innerWidth > 1023 ) {
      //   $( document ).on( 'mouseover', '.subdropdown-toggle', function() {
      //     $( '.subdropdown-menu' ).not( $( this ).attr( 'data-target' ) ).slideUp();
      //     $( '.subdropdown-toggle' ).not( this ).find( '> a' ).removeClass( 'is-open' );
      //     $( this ).find( '> a' ).addClass( 'is-open' );
      //     $( $( this ).attr( 'data-target' ) ).slideDown();
      //   } );

      //   $( '.primary-menu-item:not(.subdropdown-toggle, .dropdown-toggle-item)' ).on( 'mouseover', function() {
      //     $( '.subdropdown-toggle' ).find( '> a' ).removeClass( 'is-open' );
      //     $( '.subdropdown-menu' ).slideUp();
      //   } );
      // } else {
      //   $( document ).on( 'click', '.subdropdown-toggle', function( event ) {
      //     $( '.subdropdown-menu' ).not( $( this ).attr( 'data-target' ) ).slideUp();
      //     $( '.subdropdown-toggle' ).not( this ).find( '> a' ).removeClass( 'is-open' );
      //     if ( !$( event.target ).hasClass( 'is-open' ) ) {
      //       $( this ).find( '> a' ).addClass( 'is-open' );
      //       $( $( this ).attr( 'data-target' ) ).slideDown();
      //     } else {
      //       $( this ).find( '> a' ).removeClass( 'is-open' );
      //       $( $( this ).attr( 'data-target' ) ).slideUp();
      //     }
      //   } );
      // }

      // $( document ).on( 'click', function( event ) {
      //   if ( !$( event.target ).hasClass( 'is-open' ) && !$( event.target ).hasClass( 'link-blocker' ) ) {
      //     $( '.subdropdown-toggle' ).find( '> a' ).removeClass( 'is-open' );
      //     $( '.subdropdown-menu' ).slideUp();
      //   }
      // } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      $( document ).on( 'updateMediaQuery', ( event ) => {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );
        $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
      } );

      $( document ).on( 'click', '.add-to-quote', function() {
        let newProducts = window.getCookie( 'rmf_products' );
        if ( newProducts ) {
          newProducts = newProducts + '|' + $( this ).attr( 'data-product' );
        } else {
          newProducts = $( this ).attr( 'data-product' );
        }
        window.setCookie( 'rmf_products', newProducts );

        addedToQuoteAlert( $( this ).attr( 'data-title' ) );
      } );

      if ( $( '.form-skin .ll-file-upload' ).length > 0 && typeof( gform ) !== 'undefined' ) {
        $( 'input[type=\'file\']' ).change( function() {
          const fullPath = $( this ).val();
          let filename = fullPath.replace( /^.*[\\/]/, '' );
          if ( filename === '' ) {
            filename = 'No file chosen';
          }
          const theInput = $( this ).parent().find( '.ll-file-upload span' );
          $( theInput ).text( filename );
        } );
      }

      function addedToQuoteAlert( title ) {
        let marginTop = 16;
        $( '.added-to-quote' ).each( function() {
          marginTop = marginTop + $( this ).outerHeight() + 16;
        } );

        const id = 'quote-product-alert-' + ( new Date() ).getTime();
        $( '.added-to-quote__notifications' ).append( '<div class="added-to-quote" id="' + id + '" style="margin-top: ' + marginTop + 'px;"> <p>' + title + ' has been added to your quote!</p> <a href="' + $( '.navbar .quoter-btn a' ).attr( 'data-url' ) + '" class="secondary-btn">Request a Quote</a> </div>' );

        $( '.request-a-quote span' ).show().text( '(' + window.getCookie( 'rmf_products' ).split( '|' ).length + ')' );

        setTimeout( function() {
          const thisAlertHeight = $( '#' + id ).outerHeight();
          $( '#' + id ).fadeOut( function() {
            $( this ).remove();
          } );

          setTimeout( function() {
            $( '.added-to-quote' ).each( function( key, alert ) {
              const newMarginTop = parseInt( $( alert ).css( 'margin-top' ) ) - ( thisAlertHeight + 16 );
              $( alert ).css( 'margin-top', newMarginTop + 'px' );
            } );
          }, 500 );
        }, 5000 );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
